/**
 * Variables to configure an ITER IDEA's cloud app, together with its inner modules.
 */
export const environment = {
  idea: {
    project: 'global-web',
    app: {
      version: '1.0.4',
      bundle: 'com.iteridea.globalwebar',
      appleStoreURL: '',
      googleStoreURL: '',
      url: 'https://areariservata.globalassistance.it',
      title: 'Global Web',
      websiteURL: 'https://globalassistance.it',
      privacyPolicyURL:
        'https://sitoglobalassistance.azurewebsites.net/wp-content/uploads/2022/06/Mod.VGP_05.2022_VIAGGI-PROTETTI.pdf',
      maxFileUploadSizeMB: 10,
      tokenSavedInStorage: true
    },
    api: {
      // === dev environment
      //url: 'test-fewfine-globalassistance-integrazione.azurewebsites.net/api',
      //version: '29'
      // === test environment
      // url: 'test-fewfine-globalassistance-collaudo.azurewebsites.net/api',
      // version: '29'
      // === prod environment
      // url: 'b2b-globalportal.globalassistance.it/api',
      // version: '29'
      url: '#{api_environment}#',
      version: '29'
    },
    ionicExtraModules: ['common'],
    website: 'https://iter-idea.com'
  }
};
